import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    constructor(private http: HttpClient) { }

    paymentCoupon(jobNumber: string) {
        const endpoint = `${environment.server.api.portalpasProxy}/reports-integration/api/PaymentCoupon`;
        const { policyNumber, endorsement } = this.getPayloadData(jobNumber);

        return this.http.post(endpoint, {
            Endorsement: endorsement,
            PolicyNumberBranchOffice: policyNumber
        }, { responseType: 'blob' })
        .pipe(
            tap(file => this.downloadfile(file, `cupones-pago-${jobNumber}.pdf`))
        );
    }

    paymentReceipt(jobNumber: string) {
        const endpoint = `${environment.server.api.portalpasProxy}/reports-integration/api/ReceiptOrCreditCardPaymentByPolicy`;
        const { policyNumber, endorsement } = this.getPayloadData(jobNumber);

        return this.http.post(endpoint, {
            Endorsement: endorsement,
            PolicyNumberBranchOffice: policyNumber
        }, { responseType: 'blob' })
        .pipe(
            tap(file => this.downloadfile(file, `comprobantes-pago-${jobNumber}.pdf`))
        );
    }

    private getPayloadData(jobNumber: string) {
        // Tener en cuenta que jobNumber espera el formato de numero de endoso, no de póliza
        // @TODO: Mejorar el metodo para soportar formato de numero de poliza tambien
        const lastHyphenPosition = jobNumber.lastIndexOf('-');
        const policyNumber = jobNumber.substring(0, lastHyphenPosition);
        const endorsement = jobNumber.substring(lastHyphenPosition + 1);

        return { policyNumber, endorsement };
    }

    downloadfile(file: Blob, fileName: string) {
        const headers = new HttpHeaders();

        const linkElement = document.createElement('a');
        const blob = new Blob([file], { type: 'application/stream' });
        const urlLink = window.URL.createObjectURL(blob);

        linkElement.setAttribute('href', urlLink);
        linkElement.setAttribute('download', fileName);

        const clickEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
        });
        linkElement.dispatchEvent(clickEvent);
    }
}